import { useEffect, useState } from "react";
import { AudioWaveform } from "./AudioWaveform";

interface RecordingIndicatorProps {
  isRecording: boolean;
  volume: number;
  startTime: number | null;
}

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

export function RecordingIndicator({
  isRecording,
  volume,
  startTime,
}: RecordingIndicatorProps) {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!isRecording || !startTime) {
      setElapsedTime(0);
      return;
    }

    // Mettre à jour le temps immédiatement
    setElapsedTime(Math.floor((Date.now() - startTime) / 1000));

    const interval = setInterval(() => {
      setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [isRecording, startTime]);

  if (!isRecording) {
    return null;
  }

  return (
    <div className="absolute top-0 left-0 right-0 z-10 flex items-center gap-2 px-3 py-1 bg-red-500/90 rounded-t-surface">
      {/* Indicateur rouge pulsant */}
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
      </span>

      {/* Temps écoulé */}
      <span
        className="text-xs font-mono text-white shrink-0"
        aria-live="polite"
      >
        {formatTime(elapsedTime)}
      </span>

      {/* Waveform compact */}
      <div className="flex-1 min-w-10">
        <AudioWaveform volume={volume} isActive={isRecording} compact />
      </div>

      {/* Texte indicateur */}
      <span className="text-xs font-medium text-white/90 shrink-0">REC</span>
    </div>
  );
}
